import React from "react";
import "./WrapperCard.css";

interface WrapperCardProps {
  containerClasses?: string;
  rowClasses?: string;
  children: React.ReactNode;
}

const WrapperCard: React.FC<WrapperCardProps> = (props) => {
  let containerClasses = "container pt-3 mb-5 pl-0 pr-0";
  let rowClasses = "row mt-5 mb-2";

  return (
    <div className={props.containerClasses ? props.containerClasses : containerClasses}>
      <div className={props.rowClasses ? props.rowClasses : rowClasses}>
        <div className="offset-md-6 col-md-6 mt-5 pr-0 pt-1">
          <div className="card">
            <div className="card-body">{props.children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WrapperCard;
